"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnonymousContent = void 0;
var _components = require("@ori-ui/components");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _FavoritesDialogContent = require("./FavoritesDialogContent");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const AnonymousContent = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FavoritesDialogContent.FavoritesDialogContent, {
    testId: getTestId(_constants.ANONYMOUS_CONTENT),
    buttons: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        color: "primary",
        variant: "contained",
        onClick: _presentationUtils.doLogin,
        children: translations.logIn
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        variant: "outlined",
        href: _constants.ssoRegisterPath,
        children: translations.register
      })]
    }),
    message: translations.anonymousDialogMessage
  });
};
exports.AnonymousContent = AnonymousContent;
//# sourceMappingURL=AnonymousContent.js.map